import gql from 'graphql-tag'

export default gql`query phxGroups($group_id: ID) {
	phxGroups(group_id: $group_id) {
		id
    name
		alt_name
  }
}`
